// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { TYPE_SCALE_F5 } from 'styles/type-scale';
import {
  CLARK_PRIMARY,
  GREY_25,
  BUTTON_COLOR_PRIMARY,
  BUTTON_COLOR_SECONDARY,
  BUTTON_COLOR_TERTIARY,
  WHITE,
} from 'styles/colors';
import { BORDER_RADIUS_F2 } from 'styles/border-radius';
import { BORDER_WIDTH_1 } from 'styles/borders';
import { SPACING_MEDIUM, SPACING_LARGE } from 'styles/spacing';

import media from 'styles/media-queries';

const Button = ({
  type = 'submit',
  children,
  styleType = 'solid',
  layout = 'primary',
  onClick,
  disabled,
  path,
  className,
}: any) => (
  <ButtonContainer>
    {path ? (
      <ButtonLink to={path} layout={layout}>
        {children}
      </ButtonLink>
    ) : (
      <ButtonStyle
        className={className}
        layout={layout}
        styleType={styleType}
        type={type}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </ButtonStyle>
    )}
  </ButtonContainer>
);

export default Button;

const MAX_WIDTH = '17.5rem';

const primary = css`
  max-width: ${MAX_WIDTH};
  width: auto;
`;

const secondary = css`
  max-width: 100%;
  width: 100%;
  ${media.small`
    max-width: ${MAX_WIDTH};
    width: auto;
  `};
`;

const fullWidth = css`
  width: 100%;
`;

const buttonLayout = {
  primary: () => primary,
  secondary: () => secondary,
  fullWidth: () => fullWidth,
};

const solid = disabled => css`
  background: ${disabled
    ? GREY_25
    : `linear-gradient(109deg, ${BUTTON_COLOR_SECONDARY}, ${BUTTON_COLOR_PRIMARY})`};
  box-shadow: ${props => (props.disabled ? '' : '0 2px 8px 0 rgba(234, 73, 0, 0.2)')};
  border: 0;
  color: ${WHITE};
`;

const outline = disabled => css`
  background: ${disabled ? GREY_25 : WHITE};
  border: ${BORDER_WIDTH_1} solid ${BUTTON_COLOR_PRIMARY};
  color: ${CLARK_PRIMARY};
`;

const buttonStyleType = disabled => ({
  solid: () => solid(disabled),
  outline: () => outline(disabled),
});

const ButtonContainer = styled.div`
  width: 100%;
`;

const ButtonStyle = styled.button`
  ${({ styleType, disabled }) => buttonStyleType(disabled)[styleType]};
  ${TYPE_SCALE_F5};
  ${BORDER_RADIUS_F2};
  cursor: pointer;
  display: flex;
  justify-content: center;
  outline: 0;
  padding: ${SPACING_MEDIUM} ${SPACING_LARGE};
  ${({ layout }) => buttonLayout[layout]};
  position: relative;
  text-decoration: none;
  z-index: 0;

  &:before {
    ${BORDER_RADIUS_F2};
    background: ${BUTTON_COLOR_TERTIARY};
    background: ${({ disabled }) => (disabled ? GREY_25 : BUTTON_COLOR_TERTIARY)};
    bottom: 0;
    content: '';
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 0.25s ease-out;
    z-index: -1;
  }

  &:hover:before {
    opacity: 1;
  }
`;

const ButtonLink = ButtonStyle.withComponent(Link).extend`
  display: inline-block;
`;



// WEBPACK FOOTER //
// ./src/components/shared/button/index.js